import { useEffect, useState } from 'react';

/* Check iOS or Android by userAgent, can extend with further checks */
export default function useDetectMobile() {
  const [mobileType, setMobileType] = useState('default');

  useEffect(() => {
    const userAgent = navigator.userAgent;
    if (userAgent.match(/Android/i)) setMobileType('android');
    else if (userAgent.match(/iPhone|iPad|iPod/i)) setMobileType('iOS');
    else {
      setMobileType('default');
    }
  }, [navigator.userAgent]);

  return mobileType;
}
